module.exports = "You have been invited by <simple-link target=\"task.target.user_from\"></simple-link> to join their Circle.";